import * as Types from "../constants/actionTypes";
const initState = {
    holidays: [],
    holidayError: "",
};
export default (state = initState, action) => {
    switch (action.type) {
        case Types.HOLIDAY_FETCHED:
            return {
                ...state,
                holidays: action.payload,
            };
        case Types.HOLIDAY_ADDED:
            return {
                ...state,
                holidays: [...state.holidays, action.payload]
            };
        case Types.HOLIDAY_UPDATED:
            const updateItem = state.holidays.find(i => i.countryId === action.payload.countryId && i.date === action.payload.date);
            updateItem.description = action.payload.description;
            return {...state, holidays: [...state.holidays]};
        case Types.HOLIDAY_DELETED:
            return {
                ...state,
                holidays: state.holidays.filter(i => i.countryId !== action.payload.countryId || i.date !== action.payload.date)
            };
        case Types.HOLIDAY_ERROR:
            return {
                ...state,
                holidayError: action.payload,
            };
        default:
            return state;
    }
};
